import { init } from '@rematch/core'
import { plugins } from 'cf-core'
import { plugin as restaurantPlugin } from 'cf-models-restaurant'
import { plugin as userPlugin } from 'cf-models-user'
import * as models from 'cf-web-app/models'
import ENV from 'cf-web-app/ENV'

export const store = init({
  models,
  plugins: [
    plugins.actions,
    restaurantPlugin(ENV.RESTAURANT_ID, ENV.LOCATION_ID),
    userPlugin(ENV.STRIPE_KEY, ENV.SERVER_URL),
  ],
})

export const { dispatch, getState } = store
